import React, { useState } from "react";
import GeneralComponent from "../../../sections/BusinessDashboard/Settings/Associations/GeneraComponet";
import DashboardMainContainer from "../../../components/common/Containers/DashboardMainContainer";
import { TypeAll } from "../../../sections/BusinessDashboard/Settings/Associations/LatestData";
import {
  AdminPageTitle,
  AdminMainText,
  AdminMetadataText,
} from "../../../sections/AdminDashboard/shared/adminUx";
import { BUSINESS_CENTERED_PAGE_TITLE_CLASS } from "../../../sections/BusinessDashboard/shared/businessLayoutSpec";

const Associations = () => {
  const [type, setType] = useState("A");
  const types = "ABCDEFGHIJKLMNOPQRSTUVWXYZ"
    .split("")
    .map((letter) => ({ letter }))
    .concat([{ letter: "ALL" }]);

  const selectedAssociationsList =
    TypeAll.find((category) => category.heading === type)?.associationsList || [];

  return (
    <DashboardMainContainer className="lg:px-5 lg:pb-10">
      <AdminPageTitle className={`text-offblack ${BUSINESS_CENTERED_PAGE_TITLE_CLASS}`}>
        Associations & memberships
      </AdminPageTitle>

      <div className="min-h-screen">
        <div className="grid grid-cols-12 gap-1 mb-10 lg:mx-auto lg:w-[600px] xl:w-[700px] 2xl:w-[800px]">
          {types.map((e) => (
            <button
              key={e.letter}
              type="button"
              className={`col-span-1 ${
                type === e.letter
                  ? "bg-primaryblue text-white"
                  : "bg-white lg:bg-pastalblue text-offblack"
              } flex items-center justify-center cursor-pointer hover:bg-offblack hover:text-white py-1`}
              onClick={() => setType(e.letter)}
            >
              <AdminMetadataText className={type === e.letter ? "text-white" : ""}>
                {e.letter}
              </AdminMetadataText>
            </button>
          ))}
        </div>

        {selectedAssociationsList.length > 0 ? (
          <div
            className={
              selectedAssociationsList.length === 1
                ? "grid grid-cols-1 w-fit mx-auto"
                : "grid grid-cols-2 w-fit gap-16 mx-auto"
            }
          >
            {selectedAssociationsList.map((item, index) => (
              <GeneralComponent
                key={index}
                heading={item.heading}
                image={item.image}
                status={item.status}
              />
            ))}
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center mt-20">
            <AdminMainText className="text-offblack">Sorry</AdminMainText>
            <AdminMainText className="text-offblack mt-3 text-center block">
              The requested Association type isn&apos;t available.
            </AdminMainText>
          </div>
        )}
      </div>
    </DashboardMainContainer>
  );
};

export default Associations;
